"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _config = require("react-platform-components/dist/config");
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _MobileStepper = _interopRequireDefault(require("@material-ui/core/MobileStepper"));
var _formik = require("formik");
var _reactLoading = _interopRequireDefault(require("react-loading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    '@global': {
      body: {
        backgroundColor: "rgb(195 195 195 / 16%)"
      }
    },
    stepsWrapper: {
      paddingLeft: "35px",
      margin: "15px 0"
    },
    previousButton: {
      background: theme.palette.background.default,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      cursor: "pointer"
    },
    nextButton: {
      background: theme.palette.background.default,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      alignContent: "center",
      cursor: "pointer"
    },
    nextButtonStyling: {
      background: theme.palette.primary.main,
      color: theme.palette.third.third
    },
    submitButtonStyling: {
      background: theme.palette.secondary.secondary,
      color: theme.palette.third.contrastText
    },
    stepperStyling: {
      background: theme.palette.background.default,
      padding: '24px 0px'
      // height: "100%"
    },

    addProductText: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    savedAsDraft: {
      display: "flex",
      justifyContent: "space-between",
      paddingTop: 50,
      paddingBottom: 10
    },
    componentWrapper: function componentWrapper(props) {
      return {
        display: "flex",
        flexDirection: "column",
        height: props.navbar && props.bottomNavigation ? "calc(100vh - 120px)" : props.navbar ? "calc(100vh - 54px)" : props.bottomNavigation ? "calc(100vh - 64px)" : "100vh"
      };
    },
    paperWrapper: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "50px",
      padding: "5px 0",
      alignItems: "center"
    },
    buttonSaveAsDraftResponsive: {
      // padding: "5px 6px"
    },
    mdPaper: {
      margin: "0 0",
      width: "100%",
      flex: 1,
      overflowY: 'auto'
    },
    smPaper: {
      margin: 50
    },
    mobileStepperWrapper: {
      padding: "50px 20px"
    },
    MobileStepperStyling: {
      position: "fixed",
      bottom: "0",
      zIndex: '100'
    },
    coloredButton: {
      color: "red"
    },
    savedAsDraftButton: {
      textDecoration: "underline",
      fontWeight: "bold"
    },
    bottomPadding: {
      marginTop: 80,
      padding: "0 35px",
      boxShadow: 'rgb(0 0 0 / 10%) 0px -10px 25px -5px, rgb(0 0 0 / 4%) 0px 10px 10px -5px'
    },
    draftWrapper: {
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      background: theme.palette.background.default
    },
    loader: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  };
});
var ProductCreationRender = function ProductCreationRender(_ref) {
  var fields = _ref.fields,
    inProgress = _ref.inProgress,
    match = _ref.match,
    handleBack = _ref.handleBack,
    handleSaveAsDraft = _ref.handleSaveAsDraft,
    product = _ref.product,
    activeStep = _ref.activeStep,
    drawerWidth = _ref.drawerWidth,
    isUpdating = _ref.isUpdating,
    stepsLabels = _ref.stepsLabels,
    numberOfSteps = _ref.numberOfSteps;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        settings: state.settings.current
      };
    }),
    settings = _useSelector.settings;
  var classes = useStyle({
    navbar: settings.layout.config.toolbar.display,
    bottomNavigation: settings.layout.config.bottomNavigation !== false && _config.SHOW_ITEMS_IN_BOTTOM_BAR && window.innerWidth < 600
  });
  var isMd = (0, _core.useMediaQuery)("(max-width: 810px)");
  var _useFormikContext = (0, _formik.useFormikContext)(),
    handleSubmit = _useFormikContext.handleSubmit;
  var theme = (0, _core.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, inProgress && activeStep === numberOfSteps ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    md: 12,
    xs: 12,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: classes.loader
  }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: 'bars',
    color: theme.palette.primary.main,
    height: 60,
    width: 60
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Veuillez patienter...",
    defaultMessage: "Veuillez patienter..."
  })))) : /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, !isMd ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 0,
    className: classes.smPaper,
    variant: "elevation"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.stepsWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.savedAsDraft
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    className: classes.addProductText
  }, !isUpdating ? /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Ajouter un produit",
    defaultMessage: "Ajouter un produit"
  }) : /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Modifier un produit",
    defaultMessage: "Modifier un produit"
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 4,
    xs: 12,
    md: 12
  }, fields))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    item: true,
    xs: 12,
    md: 12,
    className: classes.bottomPadding
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.previousButton
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: activeStep !== 0 && handleBack,
    disabled: activeStep === 0 || inProgress,
    variant: "contained",
    className: classes.previousButtonStyling
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Previous",
    defaultMessage: "Previous"
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    component: _core.Grid,
    flex: 1,
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Stepper, {
    activeStep: activeStep,
    className: classes.stepperStyling
  }, stepsLabels.map(function (label, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Step, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_core.StepLabel, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: label,
      defaultMessage: label
    })));
  }))), (!match || product.status === "draft") && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.draftWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleSaveAsDraft,
    disabled: inProgress,
    className: classes.savedAsDraftButton,
    color: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "save as draft",
    defaultMessage: "save as draft"
  }))), activeStep !== stepsLabels.length - 1 ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.nextButton
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleSubmit,
    className: classes.submitButtonStyling,
    disabled: inProgress,
    variant: "contained",
    color: "primary"
  }, " ", /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Next",
    defaultMessage: "Next"
  }))) : /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.nextButton
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleSubmit,
    className: classes.submitButtonStyling,
    disabled: inProgress,
    variant: "contained",
    color: "primary"
  }, " ", /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Submit",
    defaultMessage: "Submit"
  })))))) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.componentWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "static",
    elevation: 0,
    color: "transparent"
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    minHeight: "64px",
    bgcolor: "#fafafa",
    paddingX: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: stepsLabels[activeStep],
    defaultMessage: stepsLabels[activeStep]
  })), (!match || product.status === "draft") && /*#__PURE__*/_react.default.createElement(_core.Box, {
    ml: "auto",
    minWidth: "max-content"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: inProgress,
    disableElevation: true,
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      handleSaveAsDraft();
    }
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Save as draft",
    defaultMessage: "Save as draft"
  }))))), /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 0,
    className: classes.mdPaper,
    variant: "elevation"
  }, /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mobileStepperWrapper
  }, fields))), /*#__PURE__*/_react.default.createElement(_MobileStepper.default, {
    steps: stepsLabels.length,
    position: "static",
    variant: "text",
    activeStep: activeStep,
    nextButton: activeStep !== stepsLabels.length - 1 ? /*#__PURE__*/_react.default.createElement(_core.Button, {
      size: "small",
      onClick: handleSubmit,
      disabled: activeStep === stepsLabels.length - 1
    }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Next",
      defaultMessage: "Next"
    }), /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null)) : /*#__PURE__*/_react.default.createElement(_core.Button, {
      size: "small",
      onClick: handleSubmit,
      className: classes.coloredButton,
      disabled: inProgress
    }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "SUBMIT",
      defaultMessage: "SUBMIT"
    })),
    backButton: /*#__PURE__*/_react.default.createElement(_core.Button, {
      size: "small",
      onClick: handleBack,
      disabled: activeStep === 0 || inProgress
    }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null), /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Back",
      defaultMessage: "Back"
    }))
  }))));
};
var _default = /*#__PURE__*/(0, _react.memo)(ProductCreationRender);
exports.default = _default;